export default "/images/model-desktop.png?02fb95c0b4f23f7707584d04f17ceb1c";